/* eslint-disable @typescript-eslint/naming-convention */
import { ParameterInfos } from 'ut-business/parameter';

export const encodersPositionParameters: Record<string, ParameterInfos> = {
  EncodersPosition_FiringScan: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  EncodersPosition_ScanType: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  EncodersPosition_ScanInverted: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  EncodersPosition_ScanOffset: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  EncodersPosition_ScanPreset: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  EncodersPosition_ScanResolution: {
    sourceUnit: 'steps/m',
    metric: {
      unit: 'steps/mm',
      limit: {
        min: 10,
      },
      decimals: 3,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        5,
        10,
      ],
    },
    imperial: {
      unit: 'steps/in',
      decimals: 3,
      limit: {
        min: 0.4,
      },
      defaultStep: 1,
      steps: [
        0.1,
        1,
        5,
        10,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  EncodersPosition_FiringIndex: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  EncodersPosition_IndexType: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  EncodersPosition_IndexInverted: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  EncodersPosition_IndexOffset: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  UtSettings_MaxAscanAmplitude: {
    sourceUnit: '%',
  },
  UtSettings_MinAscanAmplitude: {
    sourceUnit: '%',
  },
  EncodersPosition_IndexPreset: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  EncodersPosition_IndexResolution: {
    sourceUnit: 'steps/m',
    metric: {
      unit: 'steps/mm',
      decimals: 3,
      limit: {
        min: 10,
      },
      defaultStep: 1,
      steps: [
        0.1,
        1,
        5,
        10,
      ],
    },
    imperial: {
      unit: 'steps/in',
      decimals: 3,
      limit: {
        min: 0.4,
      },
      defaultStep: 1,
      steps: [
        0.1,
        1,
        5,
        10,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
};
